import { render, staticRenderFns } from "./theme-list.vue?vue&type=template&id=a96ec5a0&scoped=true&"
import script from "./theme-list.vue?vue&type=script&lang=js&"
export * from "./theme-list.vue?vue&type=script&lang=js&"
import style0 from "./theme-list.vue?vue&type=style&index=0&id=a96ec5a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a96ec5a0",
  null
  
)

export default component.exports